<template>
  <itemModal
    id="importSendInvoiceModal"
    modalTitle="選擇發票格式"
    modalBodyClass="px-0"
    :hideDefaultButtons="true"
    :trigger="importSendInvoiceModalTrigger"
  >
    <template #modal-buttons>
      <button type="button" class="modal-button cancel" @click="onClose">
        取消
      </button>
      <button type="button" class="modal-button done" @click="onSaved">
        確定
      </button>
    </template>
    <template #modal-body>
      <div class="inputs-group px-20px mt-5px">
        <div class="mb-8px">要開立發票並寄送Email嗎？</div>
      </div>
      <div class="item-checkboxes w-100 px-10px">
        <inputCheckboxPart
          title="格式一"
          nameProperty="importFormat1"
          :isRadio="true"
        >
          <input
            style="width: 20px; height: 20px"
            class="custom-control-input"
            type="radio"
            id="importFormat1"
            :value="0"
            v-model="importSheetType"
          />
        </inputCheckboxPart>
        <inputCheckboxPart
          title="格式二(A4)"
          nameProperty="importFormat2"
          :isRadio="true"
        >
          <input
            style="width: 20px; height: 20px"
            class="custom-control-input"
            type="radio"
            id="importFormat2"
            :value="1"
            v-model="importSheetType"
          />
        </inputCheckboxPart>
        <inputCheckboxPart
          title="格式二(中一刀)"
          nameProperty="importFormat3"
          :isRadio="true"
        >
          <input
            style="width: 20px; height: 20px"
            class="custom-control-input"
            type="radio"
            id="importFormat3"
            :value="2"
            v-model="importSheetType"
          />
        </inputCheckboxPart>
        <inputCheckboxPart
          title="格式一(A4)"
          nameProperty="importFormat4"
          :isRadio="true"
        >
          <input
            style="width: 20px; height: 20px"
            class="custom-control-input"
            type="radio"
            id="importFormat4"
            :value="3"
            v-model="importSheetType"
          />
        </inputCheckboxPart>
      </div>
    </template>
  </itemModal>
</template>

<script>
import itemModal from "@/components/modals/ItemModal.vue";
import inputCheckboxPart from "@/components/parts/inputs/InputCheckboxPart.vue";

export default {
  data() {
    return {
      importSheetType: 1,
      importSendInvoiceModalTrigger: false,
    };
  },
  props: {
    trigger: Boolean,
    defaultType: {
      type: Number,
      default: 1,
    },
  },
  emits: ["confirm", "cancel"],
  components: {
    itemModal,
    inputCheckboxPart,
  },
  watch: {
    defaultType: {
      handler(value) {
        this.importSheetType = value;
      },
      immediate: true,
    },
    trigger(value) {
      if (value) {
        this.importSendInvoiceModalTrigger = true;
      } else {
        this.importSendInvoiceModalTrigger = false;
      }
    },
  },
  methods: {
    onSaved() {
      this.$emit("confirm", this.importSheetType);
    },
    onClose() {
      this.$emit("cancel");
    },
  },
};
</script>

<style lang="scss" scoped>
#importSendInvoiceModal {
  z-index: 1001;
}
.item-checkboxes {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-shrink: 0;
  flex-grow: 1;
  flex-wrap: wrap;
}
</style>
